// Actions
import { apiFinancialPlanningCategories } from '@modules/financial-planning/api/apiFinancialPlanningCategories'
import { apiFinancialPlanningSubcategories } from '@modules/financial-planning/api/apiFinancialPlanningSubcategories'
import { apiFinancialPlanningGoals } from '@modules/financial-planning/api/apiFinancialPlanningGoals'
import { apiFinancialPlanningInvestmentAccounts } from '@modules/financial-planning/api/apiFinancialPlanningInvestmentAccounts'
import { apiFinancialPlanningInvestmentPortfolio } from '@modules/financial-planning/api/apiFinancialPlanningInvestmentPortfolio'
import { apiFinancialPlanningTransactions } from '@modules/financial-planning/api/apiFinancialPlanningTransactions'
import { apiFinancialPlanningBudgets } from '@modules/financial-planning/api/apiFinancialPlanningBudgets'
import { apiFinancialPlanningReceitasOuDespesas } from '@modules/financial-planning/api/apiFinancialPlanningReceitasOuDespesas'
import { apiFinancialPlanningSimulacoes } from '@modules/financial-planning/api/apiFinancialPlanningSimulacoes'
import { apiFinancialPlanningOpenFinance } from '@modules/financial-planning/api/apiFinancialPlanningOpenFinance'

export const clearFinancialPlanningData = ({ commit }, payload = {}) => {
  const clientId = payload.clientId || null
  commit('SET_TRANSACTIONS', { items: [], clientId })
  commit('SET_BUDGETS', { items: [], clientId })
  commit('SET_GOALS', { items: [], clientId })
  commit('SET_PATRIMONY', { items: [], clientId })
  commit('SET_PATRIMONY_GOAL_LINKS', { items: [], clientId })
  commit('SET_ASSET_GOAL_LINKS', { items: [], clientId })
  commit('SET_RULES', { items: [], clientId })
  commit('SET_INVESTMENT_ACCOUNTS', { items: [], clientId })
  commit('SET_INVESTMENT_PORTFOLIO', { data: {}, clientId })
  commit('SET_RECEITAS_OU_DESPESAS', { items: [] })
  commit('SET_OPEN_FINANCE_CLIENT_CONNECTORS', { value: [], clientId })

  // Reset lastUpdate timestamps so API cache doesn't return stale empty data
  commit('CLEAR_ALL_LAST_UPDATES')
}

export const refreshFinancialPlanning = (
  context,
  { clientId, forceUpdate = false } = {}
) => {
  if (!clientId) {
    return Promise.resolve([])
  }

  context.dispatch('clearFinancialPlanningData', { clientId })

  const loaders = [
    apiFinancialPlanningCategories.carregar({ forceUpdate }),
    apiFinancialPlanningSubcategories.carregar({ forceUpdate }),
    apiFinancialPlanningGoals.carregar({ clientId, forceUpdate }),
    apiFinancialPlanningInvestmentAccounts.carregar({
      clientId,
      forceUpdate,
    }),
    apiFinancialPlanningInvestmentPortfolio.carregar({
      clientId,
      forceUpdate,
    }),
    apiFinancialPlanningTransactions.carregar({
      clientId,
      forceUpdate,
    }),
    apiFinancialPlanningBudgets.carregar({ clientId, forceUpdate }),
    apiFinancialPlanningReceitasOuDespesas.carregar({
      clientId,
      forceUpdate,
    }),
    apiFinancialPlanningSimulacoes.carregar({
      clientId,
      forceUpdate,
    }),
    apiFinancialPlanningOpenFinance.carregarConnectors({
      forceUpdate,
    }),
    apiFinancialPlanningOpenFinance.carregarClientConnectors({
      clientId,
      forceUpdate,
    }),
  ]

  return Promise.allSettled(loaders)
}

export const setCalculadoraPgbl = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL', payload)
}
export const addCalculadoraPgbl = ({ commit }, payload) => {
  commit('ADD_CALCULADORA_PGBL', payload)
}
export const updateCalculadoraPgblSimulation = ({ commit }, payload) => {
  commit('UPDATE_CALCULADORA_PGBL_SIMULATION', payload)
}
export const setCalculadoraPgblLoading = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_LOADING', payload)
}
export const flushCalculadoraPgblData = ({ commit }) => {
  commit('FLUSH_CALCULADORA_PGBL_DATA')
}

export const setTransactions = ({ commit }, payload) => {
  commit('SET_TRANSACTIONS', payload)
}

// Filtro persistido de Transações/Orçamentos. Action só faz commit (nunca fetch).
export const setFilterOrcamentos = ({ commit }, payload) => {
  commit('SET_FILTER_ORCAMENTOS', payload)
}

export const addTransaction = ({ commit }, payload) => {
  commit('ADD_TRANSACTION', payload)
}

export const updateTransaction = ({ commit }, payload) => {
  commit('UPDATE_TRANSACTION', payload)
}

export const removeTransaction = ({ commit }, payload) => {
  commit('REMOVE_TRANSACTION', payload)
}

export const setTransactionsLoading = ({ commit }, payload) => {
  commit('SET_TRANSACTIONS_LOADING', payload)
}

export const setBudgets = ({ commit }, payload) => {
  commit('SET_BUDGETS', payload)
}

export const addBudget = ({ commit }, payload) => {
  commit('ADD_BUDGET', payload)
}

export const updateBudget = ({ commit }, payload) => {
  commit('UPDATE_BUDGET', payload)
}

export const removeBudget = ({ commit }, payload) => {
  commit('REMOVE_BUDGET', payload)
}

export const resetBudgets = ({ commit }) => {
  commit('RESET_BUDGETS')
}

export const setBudgetsLoading = ({ commit }, payload) => {
  commit('SET_BUDGETS_LOADING', payload)
}

export const setGoals = ({ commit }, payload) => {
  commit('SET_GOALS', payload)
}

export const addGoal = ({ commit }, payload) => {
  commit('ADD_GOAL', payload)
}

export const updateGoal = ({ commit }, payload) => {
  commit('UPDATE_GOAL', payload)
}

export const removeGoal = ({ commit }, payload) => {
  commit('REMOVE_GOAL', payload)
}

export const setGoalsLoading = ({ commit }, payload) => {
  commit('SET_GOALS_LOADING', payload)
}

export const setCategories = ({ commit }, payload) => {
  commit('SET_CATEGORIES', payload)
}

export const addCategory = ({ commit }, payload) => {
  commit('ADD_CATEGORY', payload)
}

export const updateCategory = ({ commit }, payload) => {
  commit('UPDATE_CATEGORY', payload)
}

export const removeCategory = ({ commit }, payload) => {
  commit('REMOVE_CATEGORY', payload)
}

export const setCategoriesLoading = ({ commit }, payload) => {
  commit('SET_CATEGORIES_LOADING', payload)
}

export const setPatrimony = ({ commit }, payload) => {
  commit('SET_PATRIMONY', payload)
}

export const addPatrimony = ({ commit }, payload) => {
  commit('ADD_PATRIMONY', payload)
}

export const updatePatrimony = ({ commit }, payload) => {
  commit('UPDATE_PATRIMONY', payload)
}

export const removePatrimony = ({ commit }, payload) => {
  commit('REMOVE_PATRIMONY', payload)
}

export const setPatrimonyLoading = ({ commit }, payload) => {
  commit('SET_PATRIMONY_LOADING', payload)
}

export const setPatrimonyGoalLinks = ({ commit }, payload) => {
  commit('SET_PATRIMONY_GOAL_LINKS', payload)
}

export const setPatrimonyGoalLinksLoading = ({ commit }, payload) => {
  commit('SET_PATRIMONY_GOAL_LINKS_LOADING', payload)
}
export const setAssetGoalLinks = ({ commit }, payload) => {
  commit('SET_ASSET_GOAL_LINKS', payload)
}

export const setAssetGoalLinksLoading = ({ commit }, payload) => {
  commit('SET_ASSET_GOAL_LINKS_LOADING', payload)
}

export const setSubcategories = ({ commit }, payload) => {
  commit('SET_SUBCATEGORIES', payload)
}

export const addSubcategory = ({ commit }, payload) => {
  commit('ADD_SUBCATEGORY', payload)
}

export const updateSubcategory = ({ commit }, payload) => {
  commit('UPDATE_SUBCATEGORY', payload)
}

export const removeSubcategory = ({ commit }, payload) => {
  commit('REMOVE_SUBCATEGORY', payload)
}

export const setSubcategoriesLoading = ({ commit }, payload) => {
  commit('SET_SUBCATEGORIES_LOADING', payload)
}

export const setRules = ({ commit }, payload) => {
  commit('SET_RULES', payload)
}

export const addRule = ({ commit }, payload) => {
  commit('ADD_RULE', payload)
}

export const updateRule = ({ commit }, payload) => {
  commit('UPDATE_RULE', payload)
}

export const removeRule = ({ commit }, payload) => {
  commit('REMOVE_RULE', payload)
}

export const setRulesLoading = ({ commit }, payload) => {
  commit('SET_RULES_LOADING', payload)
}

export const setInvestmentAccounts = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNTS', payload)
}

export const setInvestmentAccountsLoading = ({ commit }, payload) => {
  commit('SET_INVESTMENT_ACCOUNTS_LOADING', payload)
}

export const setInvestmentPortfolio = ({ commit }, payload) => {
  commit('SET_INVESTMENT_PORTFOLIO', payload)
}

export const setInvestmentPortfolioLoading = ({ commit }, payload) => {
  commit('SET_INVESTMENT_PORTFOLIO_LOADING', payload)
}
export const setOpenFinanceConnectors = ({ commit }, payload) => {
  commit('SET_OPEN_FINANCE_CONNECTORS', payload)
}
export const setOpenFinanceConnectorsLoading = ({ commit }, payload) => {
  commit('SET_OPEN_FINANCE_CONNECTORS_LOADING', payload)
}
export const setOpenFinanceClientConnectors = ({ commit }, payload) => {
  commit('SET_OPEN_FINANCE_CLIENT_CONNECTORS', payload)
}
export const setOpenFinanceClientConnectorsLoading = ({ commit }, payload) => {
  commit('SET_OPEN_FINANCE_CLIENT_CONNECTORS_LOADING', payload)
}
export const setCalculadoraPgblView = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_VIEW', payload)
}
export const setCalculadoraPgblLoadingSimulation = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_LOADING_SIMULATION', payload)
}
export const setCalculadoraPgblClients = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_CLIENTS', payload)
}
export const setCalculadoraPgblClientsLoading = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_CLIENTS_LOADING', payload)
}
export const setCalculadoraPgblClientsNameMap = ({ commit }, payload) => {
  commit('SET_CALCULADORA_PGBL_CLIENTS_NAME_MAP', payload)
}
export const setReceitasOuDespesas = ({ commit }, payload) => {
  commit('SET_RECEITAS_OU_DESPESAS', payload)
}
export const addReceitasOuDespesas = ({ commit }, payload) => {
  commit('ADD_RECEITAS_OU_DESPESAS', payload)
}
export const setReceitasOuDespesasLoading = ({ commit }, payload) => {
  commit('SET_RECEITAS_OU_DESPESAS_LOADING', payload)
}

export const setSimulacoes = ({ commit }, payload) => {
  commit('SET_SIMULACOES', payload)
}
export const addSimulacoes = ({ commit }, payload) => {
  commit('ADD_SIMULACOES', payload)
}
export const setSimulacoesLoading = ({ commit }, payload) => {
  commit('SET_SIMULACOES_LOADING', payload)
}

export const setRelatoriosInterestRegistered = ({ commit }, payload) => {
  commit('SET_RELATORIOS_INTEREST_REGISTERED', payload)
}

// Actions do editor visual de relatório (Fase B.0.3 + B.0.5).
// Mutações PURAS do override per-cliente (só commit). A PERSISTÊNCIA (PUT
// debounced) e o LOAD do backend são orquestrados pela camada de API
// (apiFinancialPlanningClientReportConfig.persistConfigClienteDebounced /
// hidratarConfigCliente), chamada pelo componente — actions não tocam a API.
export const setRelatorioSecoesAtivas = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_SECOES_ATIVAS', payload)
}
export const toggleRelatorioSecaoAtiva = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_SECAO_ATIVA', payload)
}
export const setRelatorioComentarioConsultor = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_COMENTARIO_CONSULTOR', payload)
}
export const setRelatorioComentarioEncerramento = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_COMENTARIO_ENCERRAMENTO', payload)
}
export const setRelatorioConfigEscritorio = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_ESCRITORIO', payload)
}
export const setRelatorioConfigEscritorioLoading = ({ commit }, loading) => {
  commit('SET_RELATORIO_CONFIG_ESCRITORIO_LOADING', loading)
}
export const resetRelatorioConfig = ({ commit }, payload) => {
  commit('RESET_RELATORIO_CONFIG', payload)
}
export const setRelatorioObjetivosExcluidos = ({ commit }, payload) => {
  commit('SET_RELATORIO_CONFIG_OBJETIVOS_EXCLUIDOS', payload)
}
export const toggleRelatorioObjetivoExcluido = ({ commit }, payload) => {
  commit('TOGGLE_RELATORIO_CONFIG_OBJETIVO_EXCLUIDO', payload)
}
